<script setup lang="ts">
// @ts-ignore
import i18n from '@/localization/i18n';
import {onMounted} from "vue";
// @ts-ignore
const VITE_ASSET_URL = import.meta.env.VITE_ASSET_URL
// const t = i18n.global.t
import { defineAsyncComponent } from 'vue';

const Default = defineAsyncComponent(() => import('@/views/layouts/Default.vue'));

onMounted(() => {
    document.querySelector('link[rel="canonical"]')?.setAttribute('href', document.location.href);
    if (typeof window !== 'undefined') {
        window.scrollTo(0, 0)
    }
})
</script>

<template>
    <Default>
        <!-- BEGIN: Content-->
        <div class="app-content content pt-5" style="min-height:75%; margin-left: 0px; margin-top: 5rem; background-color: white;">
            <main id="main">
                <!-- ======= Breadcrumbs ======= -->
                <section id="breadcrumbs" class="breadcrumbs">
                    <div class="container">
                        <h1>Politique de cookies</h1>
                    </div>
                </section><!-- End Breadcrumbs -->

                
                <div class="container">
                    <span class="h-style h6-style use-poppins py-0" style="font-size:14px !important;color:black">
                        <a style="text-decoration: underline !important;color:#0070C0 !important;" target="_blanc" href="https://123topela.fr">123topela.fr</a> (le <strong>« Site »</strong>)
                    </span>
                </div>

                <!-- ======= About Section ======= -->
                <section id="about" class="about pt-0 pb-0" style="margin: 0px !important;padding-bottom:45px !important">
                    <div class="container">
                        <div class="row ">
                            <div class="col-12 icon-boxes d-flex flex-column align-items-stretch justify-content-center ">
                                <div>
                                    <div class="h3 h-style h3-style use-poppins mb-3 mt-4">1. Qu’est-ce qu’un cookie ?</div>
                                    <p>
                                        Lors de votre navigation sur notre Site des cookies, pixels et autres traceurs (ci-après désignés ensemble les <strong>« Cookies »</strong>) sont déposés sur votre navigateur.
                                    </p>
                                    <p>
                                        Un Cookie est un petit ﬁchier, souvent crypté, stocké dans votre navigateur ou votre terminal et identiﬁé par un nom. Il est déposé lors de la consultation d’un site ou d’une application. Chaque fois que vous revenez sur le site ou sur l’application en question, le Cookie est récupéré sur votre navigateur ou sur votre terminal. 
                                        Ainsi, chaque fois que vous consultez le site ou l’application, le navigateur est reconnu.
                                    </p>
                                    <p>
                                        Le dépôt de ces Cookies est susceptible de nous permettre d’accéder à vos données de navigation et/ou à des données à caractère personnel vous concernant.
                                    </p>
                                    <p>
                                        Cette page vous permet de mieux comprendre comment fonctionnent les cookies et comment utiliser les outils actuels afin de les paramétrer.
                                    </p>
                                </div>
                                <div>
                                    <div class="h3 h-style h3-style use-poppins mb-3">2. Identification des cookies</div>
                                    <div>
                                        <p>
                                            <span style="text-decoration: underline;font-style: italic;">Cookies techniques et fonctionnels</span>
                                        </p>
                                        <p>
                                            Les Cookies techniques et fonctionnels sont nécessaires au bon fonctionnement du Site et pour vous fournir nos services. Ils sont utilisés tout au long de votre navigation, aﬁn de la faciliter et d’exécuter certaines fonctions.
                                        </p>
                                        <p>
                                            Un Cookie technique peut par exemple être utilisé pour mémoriser vos réponses renseignées dans un formulaire ou encore vos préférences s’agissant de la langue ou de la présentation du Site, lorsque de telles options sont disponibles. Sans ces Cookies vous ne pourrez utiliser normalement le site, nous vous déconseillons de les supprimer.
                                        </p>
                                        <p>
                                            Nous utilisons les Cookies techniques et fonctionnels suivants :
                                        </p>
                                        <div class="d-none d-md-block">
                                            <table style="width:100%;table-layout: fixed;" class="mb-4">
                                                <tr class="center-tr">
                                                    <th class="bold-th">
                                                        Nom du Cookie
                                                    </th>
                                                    <th class="bold-th"> 
                                                        Fonction du Cookie
                                                    </th>
                                                    <th class="bold-th">
                                                        Durée de conservation
                                                    </th>
                                                </tr>
                                                <tr class="at-top-tr">
                                                    <th >
                                                        <p>
                                                            topela_token
                                                        </p>
                                                    </th>
                                                    <th > 
                                                        <p>
                                                            Contient le token qui permet d’authentifier automatiquement l’utilisateur client sur le Site.
                                                        </p>
                                                    </th>
                                                    <th >
                                                        <p>
                                                            Ce cookie est conservé tant que l’utilisateur conserve le choix « Se rappeler de moi » lors de l’authentification à son espace client. <br>
                                                            Le cookie est détruit lors de la demande de déconnexion par l’utilisateur. <br>
                                                            Sinon, il est conservé avec une durée maximale de 13 mois.
                                                        </p>
                                                    </th>
                                                </tr>
                                            </table>
                                        </div>
                                        <div class="d-block d-md-none" style="width: 100%; overflow-x: auto;scrollbar-width: none;" >
                                            <table style="width:800px;table-layout: fixed;" class="mb-4 ">
                                                <tr class="center-tr">
                                                    <th class="bold-th">
                                                        Nom du Cookie
                                                    </th>
                                                    <th class="bold-th"> 
                                                        Fonction du Cookie
                                                    </th>
                                                    <th class="bold-th">
                                                        Durée de conservation
                                                    </th>
                                                </tr>
                                                <tr class="at-top-tr">
                                                    <th >
                                                        <p>
                                                            topela_token
                                                        </p>
                                                    </th>
                                                    <th > 
                                                        <p>
                                                            Contient le token qui permet d’authentifier automatiquement l’utilisateur client sur le Site.
                                                        </p>
                                                    </th>
                                                    <th >
                                                        <p>
                                                            Ce cookie est conservé tant que l’utilisateur conserve le choix « Se rappeler de moi » lors de l’authentification à son espace client. <br>
                                                            Le cookie est détruit lors de la demande de déconnexion par l’utilisateur. <br>
                                                            Sinon, il est conservé avec une durée maximale de 13 mois.
                                                        </p>
                                                    </th>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                    <div>
                                        <p>
                                            <span style="text-decoration: underline;font-style: italic;">Cookies publicitaires</span>
                                        </p>
                                        <p>
                                            Conformément aux exigences de l'Espace Économique Européen, aucun cookie à visée publicitaire n'est utilisé sur 123topela.fr. <br> 
                                            Par défaut, les fonctionnalités de stockage publicitaire, de collecte de données utilisateur et de personnalisation des annonces restent désactivées ("denied"). Ces paramètres ne seront modifiés qu'après acceptation expresse de l'utilisateur.
                                        </p>
                                    </div>
                                    <div>
                                        <p>
                                            <span style="text-decoration: underline;font-style: italic;">Cookies de personnalisation de contenu</span>
                                        </p>
                                        <p>
                                            Nous n’utilisons pas de cookies de personnalisation de contenu sur notre Site.
                                        </p>
                                    </div>
                                    <div>
                                        <p>
                                            <span style="text-decoration: underline;font-style: italic;">Cookies de réseaux sociaux</span>
                                        </p>
                                        <!-- <p>
                                            Nous n’utilisons pas de cookies de réseaux sociaux sur notre Site.
                                        </p> -->
                                        <p>
                                            Nous utilisons des cookies de réseaux sociaux, tels que Meta Pixel, afin de mesurer l’efficacité des publicités et personnaliser les annonces que vous voyez sur Facebook et Instagram. Ces cookies collectent des informations sur votre navigation pour analyser les interactions avec nos publicités.
                                        </p>
                                    </div>
                                    <div>
                                        <p>
                                            <span style="text-decoration: underline;font-style: italic;">Cookies analytiques</span>
                                        </p>
                                        <p>
                                            Ces Cookies nous permettent de mesurer le nombre de visites, le nombre de pages vues et l’activité des utilisateurs. Ils peuvent le cas échéant collecter votre adresse IP pour déterminer la ville depuis laquelle vous vous connectez. 
                                            Les Cookies analytiques nous permettent de générer des statistiques de fréquentation et de navigation de notre Site aﬁn d’améliorer nos performances. 
                                        </p>
                                        <p>
                                            Les Cookies utilisés permettent également d’identiﬁer les problèmes de navigation afin de les régler.
                                        </p>
                                        <p>
                                            Nous utilisons les Cookies analytiques suivants, liés à l’utilisation de Google Analytics :
                                        </p>
                                        <div class="d-none d-md-block">
                                            <table style="width:100%;table-layout: fixed;" class="mb-4">
                                                <tr class="center-tr">
                                                    <th class="bold-th">
                                                        Nom du Cookie
                                                    </th>
                                                    <th class="bold-th"> 
                                                        Fonction du Cookie
                                                    </th>
                                                    <th class="bold-th">
                                                        Durée de conservation
                                                    </th>
                                                </tr>
                                                <tr class="at-top-tr">
                                                    <th >
                                                        <p>
                                                            _ga
                                                        </p>
                                                    </th>
                                                    <th > 
                                                        <p>
                                                            Ce cookie est utilisé pour distinguer les utilisateurs uniques en attribuant un numéro généré de manière aléatoire en tant qu'identifiant internaute. 
                                                            Il est inclus dans chaque demande de page sur le site et est utilisé pour calculer les données d'analyse, telles que le nombre de visiteurs uniques.
                                                        </p>
                                                    </th>
                                                    <th >
                                                        <p>
                                                            Durée maximum de 6 mois.
                                                        </p>
                                                    </th>
                                                </tr>
                                                <tr class="at-top-tr">
                                                    <th >
                                                        <p>
                                                            _ga_&lt;container_id&gt;
                                                        </p>
                                                    </th>
                                                    <th >
                                                        <p>
                                                            Il s'agit d'un cookie utilisé par Google Analytics pour conserver l'état de la session.
                                                        </p>
                                                    </th>
                                                    <th >
                                                        <p>
                                                            Durée maximum de 6 mois.
                                                        </p>
                                                    </th>
                                                </tr>
<!--                                                <tr class="at-top-tr">-->
<!--                                                    <th >-->
<!--                                                        <p>-->
<!--                                                            _gid-->
<!--                                                        </p>-->
<!--                                                    </th>-->
<!--                                                    <th > -->
<!--                                                        <p>-->
<!--                                                            Ce cookie est similaire à _ga, mais il est utilisé pour distinguer les utilisateurs pendant une seule session. -->
<!--                                                        </p>-->
<!--                                                    </th>-->
<!--                                                    <th >-->
<!--                                                        <p>-->
<!--                                                            Une fois que l'utilisateur quitte le site, ce cookie expire.-->
<!--                                                        </p>-->
<!--                                                    </th>-->
<!--                                                </tr>-->
<!--                                                <tr class="at-top-tr">-->
<!--                                                    <th >-->
<!--                                                        <p>-->
<!--                                                            _gcl_au-->
<!--                                                        </p>-->
<!--                                                    </th>-->
<!--                                                    <th > -->
<!--                                                        <p>-->
<!--                                                            Ce cookie est utilisé par Google Analytics pour comprendre le comportement de l'utilisateur sur le site Web, tel que le temps passé sur le site et les pages visitées. Il est associé à la fonctionnalité de conversion Google Ads.-->
<!--                                                        </p>-->
<!--                                                    </th>-->
<!--                                                    <th >-->
<!--                                                        <p>-->
<!--                                                            Durée maximum de 6 mois.-->
<!--                                                        </p>-->
<!--                                                    </th>-->
<!--                                                </tr>-->
                                            </table>
                                        </div>
                                        <div class="d-block d-md-none" style="width: 100%; overflow-x: auto;scrollbar-width: none;">
                                            <table style="width:800px;table-layout: fixed;" class="mb-4">
                                                <tr class="center-tr">
                                                    <th class="bold-th">
                                                        Nom du Cookie
                                                    </th>
                                                    <th class="bold-th"> 
                                                        Fonction du Cookie
                                                    </th>
                                                    <th class="bold-th">
                                                        Durée de conservation
                                                    </th>
                                                </tr>
                                                <tr class="at-top-tr">
                                                    <th >
                                                        <p>
                                                            _ga
                                                        </p>
                                                    </th>
                                                    <th > 
                                                        <p>
                                                            Ce cookie est utilisé pour distinguer les utilisateurs uniques en attribuant un numéro généré de manière aléatoire en tant qu'identifiant internaute. 
                                                            Il est inclus dans chaque demande de page sur le site et est utilisé pour calculer les données d'analyse, telles que le nombre de visiteurs uniques.
                                                        </p>
                                                    </th>
                                                    <th >
                                                        <p>
                                                            Durée maximum de 6 mois.
                                                        </p>
                                                    </th>
                                                </tr>
                                                <tr class="at-top-tr">
                                                    <th >
                                                        <p>
                                                            _gid
                                                        </p>
                                                    </th>
                                                    <th > 
                                                        <p>
                                                            Ce cookie est similaire à _ga, mais il est utilisé pour distinguer les utilisateurs pendant une seule session. 
                                                        </p>
                                                    </th>
                                                    <th >
                                                        <p>
                                                            Une fois que l'utilisateur quitte le site, ce cookie expire.
                                                        </p>
                                                    </th>
                                                </tr>
                                                <tr class="at-top-tr">
                                                    <th >
                                                        <p>
                                                            _gcl_au
                                                        </p>
                                                    </th>
                                                    <th > 
                                                        <p>
                                                            Ce cookie est utilisé par Google Analytics pour comprendre le comportement de l'utilisateur sur le site Web, tel que le temps passé sur le site et les pages visitées. Il est associé à la fonctionnalité de conversion Google Ads.
                                                        </p>
                                                    </th>
                                                    <th >
                                                        <p>
                                                            Durée maximum de 6 mois.
                                                        </p>
                                                    </th>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div class="h3 h-style h3-style use-poppins mb-3">3. Vos préférences en matière de cookies</div>
                                    <div>
                                        <p>
                                            <span style="text-decoration: underline;font-style: italic;">Cookies pouvant être déposés sans consentement</span>
                                        </p>
                                        <p>
                                            Certains Cookies ne nécessitent pas votre consentement, c’est le cas des :
                                        </p>
                                        <p style="margin-left: 15x;">
                                            <ul>
                                                <li>
                                                    Cookies techniques et fonctionnels qui sont nécessaires au fonctionnement du Site ; et
                                                </li>
                                                <li>
                                                    De certains Cookies de mesure d’audience ou des Cookies qui permettent de tester des versions différentes du Site à des ﬁns d’optimisation des choix éditoriaux.
                                                </li>
                                            </ul>
                                        </p>
                                    </div>
                                    <div>
                                        <p>
                                            <span style="text-decoration: underline;font-style: italic;">L‘acceptation des Cookies soumis à votre validation</span>
                                        </p>
                                        <p>
                                            Tous les autres Cookies nécessitent votre validation. Il s’agit des Cookies de personnalisation de contenu et des Cookies d’analyse d’audience.
                                        </p>
                                        <p>
                                            Lorsque vous validez les Cookies lors de votre première navigation sur le site et que vous naviguez sur notre Site, vous acceptez explicitement l’utilisation des Cookies telle que présentée sur cette page.
                                        </p>
                                    </div>
                                    <div>
                                        <p>
                                            <span style="text-decoration: underline;font-style: italic;">Le paramétrage de votre navigateur</span>
                                        </p>
                                        <p>
                                            La plupart des navigateurs acceptent les Cookies par défaut. Cependant, vous pouvez décider de bloquer ces cookies ou demander à votre navigateur de vous avertir lorsqu’un site tente d’implémenter un cookie sur votre terminal.
                                        </p>
                                        <p>
                                            Attention, certaines fonctionnalités du Site peuvent ne plus fonctionner.
                                        </p>
                                        <p>
                                            Il est également possible de paramétrer votre navigateur aﬁn qu’il accepte ou refuse certains Cookies.
                                        </p>
                                        <p>
                                            La configuration de chaque navigateur est différente. Elle est décrite dans le menu d’aide de votre navigateur, qui vous permettra de savoir de quelle manière modifier vos souhaits en matière de Cookies.
                                        </p>
                                        <p>
                                            Chaque navigateur propose des modalités de conﬁguration diﬀérentes :
                                            <ul>
                                                <li>
                                                    Pour Internet Explorer : rendez-vous dans le menu « Paramètres », puis « Option Internet ». Cliquez sur « Conﬁdentialité » puis sur « Paramètres de conﬁdentialité avancés » ;
                                                </li>
                                                <li>
                                                    Pour Chrome : rendez-vous dans le menu « Paramètres » puis cliquez sur « Conﬁdentialité et Sécurité ». Cliquez sur « Autorisation » et « Cookies et données du sites » ;
                                                </li>
                                                <li>
                                                    Pour Safari : rendez-vous dans l’application « Réglages » puis allez sur Safari. Cliquez sur l’onglet « Conﬁdentialité et Sécurité ». Vous pouvez désormais choisir de bloquer tous les Cookies.
                                                </li>
                                            </ul>
                                        </p>
                                    </div>
                                    <div>
                                        <p>
                                            <span style="text-decoration: underline;font-style: italic;">Identiﬁants publicitaires</span>
                                        </p>
                                        <p>
                                            Des données personnelles vous concernant peuvent être collectées en lien avec votre identiﬁant publicitaire.
                                        </p>
                                        <p>
                                            Chaque téléphone mobile possède un identiﬁant publicitaire qui lui est propre et qui permet aux annonceurs de diﬀuser de la publicité ciblée.
                                        </p>
                                        <p>
                                            Android et Apple permettent aux mobinautes, dans les réglages, de maîtriser leur vie privée ce qui rend impossible le lien entre leur historique publicitaire et leurs prochaines navigations.  
                                        </p>
                                        <p>
                                            Vous pouvez désactiver et réinitialiser à tout moment votre identiﬁant publicitaire, si vous ne souhaitez plus recevoir de publicités ciblées :  
                                            <ul>
                                                <li>
                                                    Sur iOS : allez dans les "Réglages", puis dans "Conﬁdentialité", puis dans "Publicité" puis dans "Réinitialiser l'identiﬁant de publicité".
                                                </li>
                                                <li>
                                                    Sur Android : allez dans "Paramètres Google" (ou "Paramètres" puis "Google"), puis dans "Annonces".
                                                </li>
                                            </ul>
                                        </p>
                                        <p>
                                            Vous recevrez probablement la même quantité de publicités mais elles seront moins pertinentes.
                                        </p>
                                    </div>
                                </div>
                                <div>
                                    <div class="h3 h-style h3-style use-poppins mb-3">4. En savoir plus sur les cookies</div>
                                    <p>
                                        Pour plus d’information sur les cookies, vous pouvez vous rendre sur le site de la CNIL, à cette adresse : <a style="text-decoration: underline !important;color:#0070C0 !important;" target="_blanc" href="http://www.cnil.fr/vos-droits/vos-traces/les-cookies/">http://www.cnil.fr/vos-droits/vos-traces/les-cookies/</a>.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="mb-3 mt-0"></div> -->
                </section>
                <!-- End About Section -->
            </main>
        </div>
    </Default>
</template>

<style scoped>
body {
    font-family: "Century Gothic", sans-serif;
    color: #233648;
}
p {
    color: rgb(75, 75, 75);
    margin-top: 0;
    margin-bottom: 0.5rem !important;
}

ul li {
    list-style: disc;
}

table, th, td {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 5px;
  font-weight: normal;
}

.center-tr {
    vertical-align: top;
    text-align: center;
}

.at-top-tr{
    vertical-align: top;
}

.at-top-tr td {
    border: 1px solid black; 
}

.bold-th{
    font-weight: bold;
    font-size: 16px;
}
h3{
    font-size: 20px !important;
    margin-bottom: 0.5rem !important;
    margin-top:15px !important;
}

h4{
    font-size: 16px !important;
    margin-bottom: 0.2rem !important;
}
.h4{
    font-size: 16px !important;
    color: #7f6d68;
    margin-bottom: 0.2rem !important;
}

.h3{
    font-weight: bold;
    font-size: 20px !important;
    margin-bottom: 0.5rem !important;
    margin-top:15px;
}
</style>